import { useDispatch } from 'react-redux';
import useApplicationUid from './useApplicationUid';
import {
  createIraApplicationFundingAmount,
  updateIraApplicationFundingAmount,
} from '../store/actions/iraFunding/iraFundingActions';
import useIraApplicationFundingData from './useApplicationIraFundingData';

const useIraApplicationFundingAmountDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();
  const { IraApplicationFundingResponse } = useIraApplicationFundingData();

  const iraApplicationFundingAmountDispatch = ({
    data,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const shouldSkip = data?.FundAmount === defaultValues?.FundAmount;

    if (shouldSkip) {
      onSuccess();
      return;
    }

    if (IraApplicationFundingResponse?.Amount) {
      dispatch(
        updateIraApplicationFundingAmount({
          ApplicationUid,
          data: {
            Amount: data?.FundAmount,
          },
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        createIraApplicationFundingAmount({
          ApplicationUid,
          data: {
            Amount: data?.FundAmount,
          },
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { iraApplicationFundingAmountDispatch };
};

export default useIraApplicationFundingAmountDispatch;
